import { linkListStyles } from "@insite/content-library/Widgets/Basic/SocialLinks";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

linkListStyles.socialLinkListWrapper = {
    css: css`
        width: 60%;
        padding: 0;
        margin-left: auto;
        align-items: flex-end;
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    css`
                        margin: auto !important;
                        width: 100%;
                    `,
                    css`
                        margin: auto !important;
                        width: 100%;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            );
        }}
    `,
};

linkListStyles.linkWrapper = {
    css: css`
        margin: auto;
        max-width: 40px;
        flex-shrink: 0;
        background-color: white;
        border-radius: 50%;
        display: flex;
        justify-content: center;
    `,
};
